
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    inputClass: {
      type: String,
      default: "text-gray-text",
    },
    border: {
      type: String,
      default: "border",
    },
    label: {
      type: String,
      default: "",
    },
    labelFor: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
};
